import React from 'react';
import PropTypes from 'prop-types';
import { refSetter } from '../../../utils/helpers';

class DropdownWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      label: props.label,
    };
  }

  componentWillReceiveProps = nextProps => {
    if (this.props.externalLabel) {
      this.setState({ label: nextProps.label });
    }
  };

  setRef = refSetter.bind(this);

  setLabel = name => {
    this.setState({ label: name });
  };

  getDropdownContentStyle = () => ({ display: this.state.isOpen ? 'block' : 'none' });

  close = () => {
    this.setState({ isOpen: false });
    document.removeEventListener('click', this.hide);
  };

  show = () => {
    if (this.props.disabled) {
      return;
    }

    this.setState({ isOpen: true });
    document.addEventListener('click', this.hide);
  };

  hide = e => {
    e.stopPropagation();
    if (
      this.dropdownContent &&
      (!this.dropdownContent.contains(e.target) &&
        // For some reason, the browser sometimes thinks the node doesn't exists inside the document,
        // (odd result means "the two nodes do not belong to the same document")
        // despite it being right there...
        this.dropdownContent.compareDocumentPosition(e.target) % 2 === 0)
    ) {
      this.close();
    }
  };

  render() {
    const { contentDirection, children, disabled } = this.props;
    const { isOpen, label } = this.state;

    const childrenWithProps = React.Children.map(children, child => {
      if (typeof child.type === 'function') {
        return React.cloneElement(child, {
          setLabel: this.setLabel,
          close: this.close,
        });
      }
      return child;
    });

    return (
      <div className="dropdown" onClick={this.show} role="presentation">
        <button className="dropdown-button" disabled>
          <div className="label">{label}</div>
          {!disabled && (
            <i className={`icon-extend icon-xsmall icon-${isOpen ? 'contract-option' : 'expand-option'}`} />
          )}
        </button>
        <div
          ref={this.setRef('dropdownContent')}
          className={`dropdown-content${contentDirection === 'left' ? ' left' : ' right'}`}
          style={this.getDropdownContentStyle()}
        >
          {childrenWithProps}
        </div>
      </div>
    );
  }
}

DropdownWrapper.defaultProps = {
  label: '',
  contentDirection: 'left',
  maxWidth: null,
  externalLabel: false,
  disabled: false,
};

DropdownWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  disabled: PropTypes.bool,
  contentDirection: PropTypes.string,
  externalLabel: PropTypes.bool,
};

export default DropdownWrapper;
